import { render } from "./ServicesSlider.vue?vue&type=template&id=6a870578"
import script from "./ServicesSlider.vue?vue&type=script&lang=js"
export * from "./ServicesSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__